<div class="box bg-light-grey">
    <div class="d-flex justify-content-start align-items-center w-100">
        <div class="box-icon mr-1">
                <img src="./../../../../assets/icons/account.svg"/>
        </div>
        <div class="box-text">
            {{ text }} 
        </div>
    </div>
</div>